import script from "./ContraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContraModal.vue?vue&type=script&setup=true&lang=js"

import "./ContraModal.vue?vue&type=style&index=0&id=a6b543c6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b543c6"]])

export default __exports__